import React, {useRef } from 'react'
import {
    Card,
    Progress
} from "@material-tailwind/react";

import { useShared } from '../../hooks/useShared';
import AIcon from '../partials/AIcon';
import Resizer from "react-image-file-resizer";



export default function UploadImage({ v }) {
    const { auth, progress, setProgress, model, consts, http } = useShared();
    const inputFile = useRef(null)

    console.log("iamge files ", v);

    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                600,
                900,
                "JPEG",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "file"
            );
        });



    const onFileChange = async (event) => {
        const fls = event.target.files;
        console.log(v.files, "files ", fls)
        // v.setFiles(fls);
        for (let i = 0; i < fls.length; i++) {
            let existing = v.files?.some(f => f.name === fls[i].name && f.size === fls[i].size); //check duplicate files
            if (!existing) {
                const mFile = await resizeFile(fls[i])
                v.setFiles(pre => [...pre,
                {
                    name: mFile.name,
                    file: mFile,
                    size: mFile.size,
                    temp_file: window.URL.createObjectURL(mFile)
                }])
            }
        }

        setProgress(0)
    };



    const handleClick = (e) => {
        e.preventDefault();
        inputFile.current.click()
    }

    const openInNewTab = (obj) => {
        console.log(obj);
        obj?.id > 0 ? window.open(consts.BASE_URL + obj?.path) : window.open(obj?.temp_file)
    }

    const removePhoto = async (e, i, obj) => {
        e.stopPropagation();
        if (window.confirm("Do you want to delete it?")) {
            const copy = [...v.files]
            copy.splice(i, 1)
            v.setFiles(copy)
            inputFile.current.value = null;
            if (obj?.id && obj?.id > 0) {
                try {
                    const res = await http.post('api/remove/photo', { attachment: obj })
                    console.log("remove attachment ... ", res);
                    if (res.data.success) {

                    }
                } catch (error) {
                    console.log('error photo remove ', error);
                }
            }

        }

    }


    return (
        <div className={`w-full p-2 mt-2  relative ${v.className}`}>
            <Card className={`p-3 grid  `}>
                <p className="text-sm text-main-color font-bold mb-3 border-b pb-2">Upload Attachments </p>
                <div className={` cursor-pointer relative border border-main-color 
                flex items-center justify-center bg-contain bg-no-repeat 
                h-[50px] bg-center w-full md:w-[10%] rounded-md `} onClick={handleClick} >
                    <AIcon name="add-outline" size={50} className="text-main-color " />
                </div>
                <input
                    style={{ display: 'none' }}
                    ref={inputFile}
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={onFileChange}
                />

                {progress > 0 && <Progress color="green" value={progress} label="Completed" />}

                {v.files?.length > 0 &&
                    <div className={`mt-2 flex `}>
                        {
                            v.files?.map((f, i) => {
                                return (
                                    <div key={i}
                                        className="h-[100px] w-[100px] grid-flow-col border border-dotted cursor-pointer bg-cover bg-center rounded-md relative"
                                        style={{ backgroundImage: `url(${f?.temp_file?f?.temp_file: consts.BASE_URL + f.path})` }} onClick={() => openInNewTab(f)}>
                                        {((model?.staus===1 && auth?.isCreator(model?.ceator_id))|| auth.hasRole([1,2]) )&& <AIcon name="close" className="text-red-900 cursor-pointer hover:text-red-600 absolute top-0 right-0" size={20} onClick={(e) => removePhoto(e,i, f)} /> }
                                        
                                    </div>
                                )

                            })
                        }
                    </div>
                }

            </Card>
        </div>
    )
}
